/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { fetchProviderInfo } from "../api/providerInfo";

export function useProviderInfo(user, isAdmin, setLoading, setProviderInfo) {
  useEffect(() => {
    if (!!user) {
      setLoading(true);
      if (!isAdmin) {
        console.log("Not admin => fetch providerInfo");
        fetchProviderInfo("", user.token)
          .then((data) => {
            console.log("RES", data);
            setProviderInfo(data);
          })
          .catch(() => {
            // means we got a non 2XX status code => provider info does not exist
            // => disable the navigation buttons
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        console.log("Admin => fetch providersList");
      }
    } else {
      console.log("No user logged in");
    }
  }, [user, isAdmin]);
}
